(() => {
  const enhance = (root) => {
    const banner = root.matches?.('#shopify-pc__banner')
      ? root
      : root.querySelector?.('#shopify-pc__banner');
    const manage = banner?.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (manage && manage !== manage.parentElement.lastElementChild) {
      manage.parentElement.append(manage);
    }

    const dialog = root.matches?.('#shopify-pc__prefs__dialog')
      ? root
      : root.querySelector?.('#shopify-pc__prefs__dialog');
    const actions = dialog?.querySelector('.shopify-pc__prefs__header-actions');
    const content = dialog?.querySelector('.shopify-pc__prefs__scrollable');
    if (!actions || !content || dialog.dataset.beadifiqueCookieLayout) return;

    dialog.append(actions);
    dialog.dataset.beadifiqueCookieLayout = 'ready';
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const controls = Array.from(dialog.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]'
      )).filter((control) => control.tabIndex >= 0 && !control.disabled && control.getClientRects().length);
      if (!controls.length) return;
      const first = controls[0];
      const last = controls[controls.length - 1];
      event.stopImmediatePropagation();
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    }, true);
  };

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1) enhance(node);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  enhance(document);
})();
